import React from "react";
import "./productAchievement.scss"
import {deptPerformance,userPerformance} from "../../api/index"
import { Calendar } from 'antd-mobile';
import up from '../../public/image/up.png'
import down from '../../public/image/down.png'
import {getDay,getMonthStartDateAndDateRange,getWeekStartDateAndEndDateRange,_dateFormatMySelf} from '../../utils/index'
import SelectDiv from '../../components/selectDiv/selectDiv'

export default class ProductAchievement extends React.Component{
    constructor(props){
        super(props);
        this.state={
            time:[_dateFormatMySelf(getWeekStartDateAndEndDateRange()[0]),_dateFormatMySelf(getWeekStartDateAndEndDateRange()[1])],
            timeText:`${_dateFormatMySelf(getWeekStartDateAndEndDateRange()[0])}至${_dateFormatMySelf(getWeekStartDateAndEndDateRange()[1])}`,
            dateValue:2,
            DateArray:[{
                value:1,
                name:"今日"
            },{
                value:2,
                name:"本周"
            },{
                value:3,
                name:"本月"
            }],
            jxdata:[],
            timeShow:false
        }
        
    }
    changeType(val){
        if(val.value==1){
            this.setState({
                time:[_dateFormatMySelf(new Date()),_dateFormatMySelf(new Date())],
                timeText:`${_dateFormatMySelf(new Date())}至${_dateFormatMySelf(new Date())}`
            })
        }else if(val.value==2){
            this.setState({
                time:[_dateFormatMySelf(getWeekStartDateAndEndDateRange()[0]),_dateFormatMySelf(getWeekStartDateAndEndDateRange()[1])],
                timeText:`${_dateFormatMySelf(getWeekStartDateAndEndDateRange()[0])}至${_dateFormatMySelf(getWeekStartDateAndEndDateRange()[1])}`
            })
        }else if(val.value==3){
            this.setState({
                time:[_dateFormatMySelf(getMonthStartDateAndDateRange()[0]),_dateFormatMySelf(getMonthStartDateAndDateRange()[1])],
                timeText:`${_dateFormatMySelf(getMonthStartDateAndDateRange()[0])}至${_dateFormatMySelf(getMonthStartDateAndDateRange()[1])}`
            })
        }
        
        this.setState({
            dateValue:val.value
        },()=>{
           this.getDpi(); 
        })
    }
    openTime(){
        this.setState({
            timeShow:true
        })
    }
    onCanceltime(){
        this.setState({
            timeShow:false
        })
    }
    onConfirm(startDate,endDate){
        this.setState({
            timeShow:false,
            time:[_dateFormatMySelf(startDate),_dateFormatMySelf(endDate)],
            timeText:`${_dateFormatMySelf(startDate)}至${_dateFormatMySelf(endDate)}`
        },()=>{
            this.getDpi(); 
        })
    }
    render(){
       const now = new Date();
        return(
            <div className="ProductAchievement">
                <div className="time">
                    <SelectDiv
                        style={{width:'29.33vw',marginRight:'12px'}}
                        model={this.state.dateValue} 
                        data={this.state.DateArray}
                        noIcon={true}
                        changeType={this.changeType.bind(this)}
                    />
                    <SelectDiv  style={{flex:1}}
                                showIcon={false}
                                title={this.state.timeText}
                                type='text'
                                topDivClick={this.openTime.bind(this)}
                            />
                </div>
                <div className="jx">
                    <div className="top">
                        <span className="title">总绩效(元)</span>
                        <span className="num">{this.state.totalNum}</span>
                    </div>
                    <div className="content">
                        {
                            this.state.jxdata.map((s)=>{
                                return <div >
                                            <div className={`partInfo ${s.isOpen?'activeDip':''}`} onClick={()=>{this.getUserData(s)}}>
                                                <div className="partTop">
                                                    <span>{s.name}</span>
                                                    <div>
                                                        <img src={s.isOpen?up:down}/>
                                                    </div>
                                                    
                                                </div>
                                                <p>{s.cnt}</p>
                                            </div>
                                            <div className={`userMx ${s.isOpen?'activeUser':''}`}>
                                                <div className="userTop">
                                                    <span>姓名</span>
                                                    <span>绩效(元)</span>
                                                </div>
                                                <ul>
                                                    {s.userInfo&&s.userInfo.map((ss)=>{
                                                        return <li>
                                                            <span>{ss.name}</span>
                                                            <span style={{float:'right'}}>{ss.cnt}</span>
                                                        </li>
                                                    })}
                                                </ul>
                                            </div>
                                        </div>
                            })
                        }
                    </div>
                </div>
                <Calendar
                    visible={this.state.timeShow}
                    onCancel={this.onCanceltime.bind(this)}
                    onConfirm={(startDate,endDate)=>{this.onConfirm(startDate,endDate)}}
                    defaultDate={now}
                    
                />
            </div>
        )
    }
    async getUserData(s){
        let obj={
            beginAt:this.state.time[0],
            endAt:this.state.time[1],
            deptId:s.id
        }
        let res=await userPerformance(obj);
        if(res.code==0){
            let datas=this.state.jxdata;
            datas.forEach((item)=>{
                if(item.id==s.id){
                    item.userInfo=res.data;
                    item.isOpen=!item.isOpen;
                }
            })
            console.log("datas",datas)
            this.setState({
                jxdata:datas
            })
            
        }
    }
    componentWillReceiveProps(nextProps) {
        
        
        
    }
    async getDpi(){
        let obj={
            beginAt:this.state.time[0],
            endAt:this.state.time[1]
        }
        let res=await deptPerformance(obj);
        if(res.code==0){
            let num=0;
            if(res.data){
                for(let item of res.data){
                    num+=item.cnt
                }
                this.setState({
                    jxdata:res.data,
                    totalNum:num.toFixed(2)
                })
            }
            
            
        }
    }
    async componentDidMount(){
        this.getDpi();
    }
}

